var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { blameLogs } from '@debbie/cortex/dist/api';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Currency, ExportType } from '@debbie/common/dist';
import keys from '@debbie/common/dist/cache/keys';
import { CaseVoucherSource, State, } from '@debbie/common/dist/economy/case-vouchers';
import { DebtorVoucherTypes } from '@debbie/common/dist/economy/vouchers/setup';
import { arrayIntersection, objectBy } from '@debbie/common/dist/util';
import { useMutation } from '@debbie/common/dist/util/hooks';
import { c, h } from '@debbie/cortex/dist';
import { delCaseVoucher, patchCaseVoucher, } from '@debbie/cortex/dist/api/case-vouchers';
import { caseVouchersEntity, useCaseVouchers, } from '@debbie/cortex/dist/case-vouchers';
import { selectVoucherTypes } from '@debbie/cortex/dist/economy/selectors';
import { downloadFile } from '@debbie/cortex/dist/files';
import q from '@debbie/cortex/dist/query';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import { APIBASE } from '../config';
import THEME from '../theme';
import Badge from './Badge';
import Button from './Button';
import CasePreview from './CasePreview';
import { X } from './Icons';
import Modal from './Modal';
import Money from './Money';
import * as filters from './power-table/Filters';
import RemoteTable from './RemoteTable';
import Search from './Search';
import Select from './Select';
import Timestamp from './Timestamp';
import { BlameLogRefType, BlameLogType } from '@debbie/common/dist/blamelog';
const CaseVoucherTable = (props) => {
    var _a, _b;
    const lang = useSelector((s) => s.lang);
    const tenantId = useSelector(selectTenantId);
    const voucherTypes = ((_a = useSelector(selectVoucherTypes)) !== null && _a !== void 0 ? _a : []).map((ut) => ut.voucherTypeId);
    const voucherTypesLoader = useSelector((s) => s.economyVoucherTypes);
    const [selected, setSelected] = useState([]);
    const [exportType, setExportType] = useState(ExportType.Csv);
    const [mapperModalOpen, setMapperModalOpen] = useState(false);
    const [mapperCaseVoucher, setMapperCaseVoucher] = useState(undefined);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteCaseVoucher, setDeleteCaseVoucher] = useState(undefined);
    useEffect(() => {
        if (h.isNotLoaded(voucherTypesLoader)) {
            c.economy.getVoucherTypes();
        }
    }, [voucherTypesLoader]);
    const excludedFilters = (_b = props.excludeFilter) !== null && _b !== void 0 ? _b : [];
    return (React.createElement("div", null,
        props.selectable ? (React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '1em',
                paddingBottom: '1em',
                borderBottom: '1px solid lightgray',
            } },
            React.createElement(Select, { labelStyle: { margin: '0', minWidth: '100px' }, value: exportType, onChange: (e) => {
                    setExportType(e.currentTarget.value);
                } },
                React.createElement("option", { value: ExportType.Csv }, "CSV"),
                React.createElement("option", { value: ExportType.Xlsx }, "XLSX")),
            React.createElement(Button, { disabled: selected.length === 0, download: true, onClick: () => {
                    downloadFile(`${APIBASE}/v1/${tenantId}/case-vouchers/export`, exportType === ExportType.Csv
                        ? `${lang.caseVouchers.exportFileName}.csv`
                        : `${lang.caseVouchers.exportFileName}.xlsx`, {
                        method: 'POST',
                        body: JSON.stringify({
                            exportType: exportType,
                            ids: selected,
                        }),
                    });
                } },
                lang.misc.export,
                " (",
                selected.length,
                ")"))) : null,
        React.createElement(RemoteTable, { useFetch: (filters, page, pageSize) => useCaseVouchers(Object.assign(Object.assign({}, filters), props.filter), page, pageSize), selectable: props.selectable, selectKey: (cv) => cv.caseVoucherId, onSelect: setSelected, selected: selected, genKey: (cv) => cv.caseVoucherId, sortKeyKey: "sortKey", sortDirectionKey: "sortDirection", initFilters: {}, pageSize: props.pageSize, values: {
                id: {
                    label: lang.economy.voucherInfoId,
                    width: '100px',
                },
                voucherTypeId: Object.assign({ label: lang.misc.type, width: '150px', map: (type) => {
                        return type
                            ? lang.economyVoucherTypeLabels[type]
                            : '';
                    }, sortable: false }, (!excludedFilters.includes('voucherTypeId')
                    ? {
                        filter: (props) => {
                            return (React.createElement(filters.CategoryFilter, { categories: objectBy(arrayIntersection(voucherTypes, DebtorVoucherTypes).map((id) => {
                                    return {
                                        id,
                                        label: lang.economyVoucherTypeLabels[id],
                                    };
                                }), (ctx) => ctx.id), selected: props.filter.voucherTypeIds != null
                                    ? props.filter.voucherTypeIds
                                    : [], onChange: (ids) => {
                                    props.setFilter(Object.assign(Object.assign({}, props.filter), { voucherTypeIds: ids.length > 0 ? ids : undefined }));
                                } }));
                        },
                        filterActive: (filter) => filter.voucherTypeIds != null &&
                            filter.voucherTypeIds.length > 0,
                    }
                    : {
                        filter: undefined,
                        filterActive: undefined,
                    })),
                date: Object.assign({ label: lang.misc.date, map: (x) => React.createElement(Timestamp, { date: x }) }, (!excludedFilters.includes('date')
                    ? {
                        filter: (props) => {
                            var _a, _b;
                            return (React.createElement(filters.DateRangeFilter, { from: (_a = props.filter.fromDate) !== null && _a !== void 0 ? _a : null, to: (_b = props.filter.toDate) !== null && _b !== void 0 ? _b : null, onChange: (fromDate, toDate) => {
                                    props.setFilter(Object.assign(Object.assign({}, props.filter), { fromDate: fromDate !== null && fromDate !== void 0 ? fromDate : undefined, toDate: toDate !== null && toDate !== void 0 ? toDate : undefined }));
                                } }));
                        },
                        filterActive: (filter) => filter.fromDate != null || filter.toDate != null,
                    }
                    : {
                        filter: undefined,
                        filterActive: undefined,
                    })),
                text: {
                    label: lang.misc.text,
                    sortable: false,
                    width: '150px',
                },
                source: Object.assign({ label: lang.caseVouchers.source, map: (k) => lang.caseVoucherSources[k] }, (!excludedFilters.includes('source')
                    ? {
                        filter: (props) => {
                            return (React.createElement(filters.CategoryFilter, { categories: objectBy(Object.values(CaseVoucherSource).map((source) => {
                                    return {
                                        id: source,
                                        label: lang.caseVoucherSources[source],
                                    };
                                }), (ctx) => ctx.id), selected: props.filter.sources != null
                                    ? props.filter.sources
                                    : [], onChange: (ids) => {
                                    props.setFilter(Object.assign(Object.assign({}, props.filter), { sources: ids.length > 0
                                            ? ids
                                            : undefined }));
                                } }));
                        },
                        filterActive: (filter) => filter.sources != null && filter.sources.length > 0,
                    }
                    : { filter: undefined, activeFilter: undefined })),
                state: Object.assign({ label: lang.misc.state, sortable: false, map: (state) => state ? (React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.caseVoucherStates[state])) : ('') }, (!excludedFilters.includes('state')
                    ? {
                        filter: (props) => {
                            return (React.createElement(filters.CategoryFilter, { categories: objectBy(Object.values(State).map((state) => {
                                    return {
                                        id: state,
                                        label: lang.caseVoucherStates[state],
                                    };
                                }), (ctx) => ctx.id), selected: props.filter.states != null ? props.filter.states : [], onChange: (states) => {
                                    props.setFilter(Object.assign(Object.assign({}, props.filter), { states: states.length > 0
                                            ? states
                                            : undefined }));
                                } }));
                        },
                        filterActive: (filter) => filter.states != null && filter.states.length > 0,
                    }
                    : {
                        filter: undefined,
                        filterActive: undefined,
                    })),
                amount: Object.assign({ label: lang.economy.amount, map: (amount) => React.createElement(Money, { color: true, amount: amount }), align: 'right' }, (!excludedFilters.includes('amount')
                    ? {
                        filter: (props) => {
                            var _a, _b;
                            return (React.createElement("div", null,
                                React.createElement(filters.MoneyRangeFilter, { from: (_a = props.filter.fromAmount) !== null && _a !== void 0 ? _a : null, to: (_b = props.filter.toAmount) !== null && _b !== void 0 ? _b : null, onChange: (fromAmount, toAmount) => {
                                        props.setFilter(Object.assign(Object.assign({}, props.filter), { fromAmount: fromAmount !== null && fromAmount !== void 0 ? fromAmount : undefined, toAmount: toAmount !== null && toAmount !== void 0 ? toAmount : undefined }));
                                    } })));
                        },
                        filterActive: (filter) => filter.fromAmount != null || filter.toAmount != null,
                    }
                    : {
                        filter: undefined,
                        filterActive: undefined,
                    })),
                currency: Object.assign({ label: lang.economy.currency, map: (c) => React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, c) }, (!excludedFilters.includes('currency')
                    ? {
                        filter: (props) => {
                            return (React.createElement("div", null,
                                React.createElement(filters.CategoryFilter, { categories: objectBy(Object.values(Currency).map((currency) => {
                                        return {
                                            id: currency,
                                            label: currency,
                                        };
                                    }), (ctx) => ctx.id), selected: props.filter.currencies != null
                                        ? props.filter.currencies
                                        : [], onChange: (ids) => {
                                        props.setFilter(Object.assign(Object.assign({}, props.filter), { currencies: ids.length > 0
                                                ? ids
                                                : undefined }));
                                    } })));
                        },
                        filterActive: (filter) => filter.currencies != null && filter.currencies.length > 0,
                    }
                    : { filter: undefined, filterActive: undefined })),
                expirationDate: Object.assign({ label: lang.caseVouchers.expirationDate, map: (d) => (d ? React.createElement(Timestamp, { date: d }) : '') }, (!excludedFilters.includes('expirationDate')
                    ? {
                        filter: (props) => {
                            var _a, _b;
                            return (React.createElement("div", null,
                                React.createElement(filters.DateRangeFilter, { from: (_a = props.filter.fromExpirationDate) !== null && _a !== void 0 ? _a : null, to: (_b = props.filter.toExpirationDate) !== null && _b !== void 0 ? _b : null, onChange: (fromDate, toDate) => {
                                        props.setFilter(Object.assign(Object.assign({}, props.filter), { fromExpirationDate: fromDate !== null && fromDate !== void 0 ? fromDate : undefined, toExpirationDate: toDate !== null && toDate !== void 0 ? toDate : undefined }));
                                    } })));
                        },
                        filterActive: (filter) => filter.fromExpirationDate != null ||
                            filter.toExpirationDate != null,
                    }
                    : { filter: undefined, filterActive: undefined })),
                expired: {
                    label: lang.caseVouchers.expired,
                    map: (expired) => (expired ? lang.misc.yes : lang.misc.no),
                    filter: (props) => {
                        return (React.createElement(filters.BooleanFilter, { filter: {
                                showTrue: props.filter.expired,
                            }, onChange: (filter) => {
                                props.setFilter(Object.assign(Object.assign({}, props.filter), { expired: filter.showTrue }));
                            } }));
                    },
                    filterActive: (filter) => filter.expired != null,
                },
                irrecoverableDate: Object.assign(Object.assign({}, (!excludedFilters.includes('irrecoverableDate')
                    ? {
                        filterActive: (filter) => {
                            return (filter.fromIrrecoverableDate != null ||
                                filter.toIrrecoverableDate != null);
                        },
                        filter: (props) => {
                            var _a, _b;
                            return (React.createElement("div", null,
                                React.createElement(filters.DateRangeFilter, { from: (_a = props.filter.fromIrrecoverableDate) !== null && _a !== void 0 ? _a : null, to: (_b = props.filter.toIrrecoverableDate) !== null && _b !== void 0 ? _b : null, onChange: (fromDate, toDate) => {
                                        props.setFilter(Object.assign(Object.assign({}, props.filter), { fromIrrecoverableDate: fromDate !== null && fromDate !== void 0 ? fromDate : undefined, toIrrecoverableDate: toDate !== null && toDate !== void 0 ? toDate : undefined }));
                                    } })));
                        },
                    }
                    : { filter: undefined, filterActive: undefined })), { label: lang.caseVouchers.irrecoverableDate, map: (d) => (d ? React.createElement(Timestamp, { date: d }) : '') }),
                createdAt: {
                    label: lang.misc.createdAt,
                    map: (date, cv) => React.createElement(Timestamp, { date: date }),
                },
                caseId: {
                    label: lang.caseVouchers.case,
                    map: (caseId, cv) => caseId ? (
                    // @ts-ignore
                    React.createElement(Link, { to: `/cases/${caseId}` }, lang.misc.goToCase)) : (React.createElement("div", { style: { display: 'flex', gap: 4 } },
                        React.createElement(Button, { onClick: () => {
                                setMapperCaseVoucher(cv.caseVoucherId);
                                setMapperModalOpen(true);
                            }, size: "small" }, lang.caseVouchers.map),
                        props.deleteable && (React.createElement(Button, { size: "small", theme: "dangerous", onClick: () => {
                                setDeleteCaseVoucher(cv.caseVoucherId);
                                setDeleteModalOpen(true);
                            } }, lang.misc.delete)))),
                    width: '120px',
                    sortable: false,
                },
            } }),
        mapperModalOpen && mapperCaseVoucher ? (React.createElement(Modal, { maxWidth: "400px", onToggle: () => setMapperModalOpen(false), header: lang.caseVouchers.mapHeader },
            React.createElement(CaseSelector, { caseVoucherId: mapperCaseVoucher, onSubmit: () => {
                    setMapperCaseVoucher(undefined);
                    setMapperModalOpen(false);
                } }))) : null,
        deleteModalOpen && deleteCaseVoucher && (React.createElement(Modal, { maxWidth: "400px", onToggle: () => setDeleteModalOpen(false), header: lang.economy.voucherInfoDeleteVoucher },
            React.createElement(CaseVoucherDeleteModal, { caseVoucherId: deleteCaseVoucher, onSubmit: () => {
                    setDeleteModalOpen(false);
                    setDeleteCaseVoucher(undefined);
                } })))));
};
const CaseVoucherDeleteModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const model = useMutation((caseVoucherId) => delCaseVoucher(caseVoucherId), {
        onSuccess: (res, caseVoucherId) => {
            q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucherId));
            if (props.onSubmit) {
                props.onSubmit();
            }
        },
    });
    return (React.createElement("div", null,
        React.createElement("p", null, lang.caseVouchers.deleteWarning),
        React.createElement("div", { style: { display: 'flex', gap: 4 } },
            React.createElement(Button, { theme: "dangerous", style: { width: '100%' }, loading: model.isLoading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    model.mutate(props.caseVoucherId);
                }) }, lang.misc.delete),
            React.createElement(Button, { theme: "secondary", style: { width: '100%' }, loading: model.isLoading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    props.onSubmit && props.onSubmit();
                }) }, lang.misc.cancel))));
};
const CaseSelector = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenantId = useSelector(selectTenantId);
    const [caseCtx, setCaseCtx] = useState(null);
    const model = useMutation((caseVoucherId, caseId) => patchCaseVoucher(caseVoucherId, {
        caseId,
    }), {
        onSuccess: (res, caseVoucherId) => {
            q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucherId));
            if (props.onSubmit) {
                props.onSubmit();
            }
        },
    });
    return (React.createElement("div", null,
        caseCtx ? (React.createElement(SelectedCase, null,
            React.createElement(CasePreview, { caseId: caseCtx.caseSeqId }),
            React.createElement(X, { style: { cursor: 'pointer' }, onClick: () => {
                    setCaseCtx(null);
                } }))) : (React.createElement(Search, { removeWrapper: true, onSelect: (result) => {
                setCaseCtx(result);
            } })),
        React.createElement(Button, { style: { width: '100%' }, disabled: caseCtx == null, loading: model.isLoading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                if (caseCtx === null || caseCtx === void 0 ? void 0 : caseCtx.objectID) {
                    model.mutate(props.caseVoucherId, caseCtx.objectID);
                    const blameLog = {
                        details: props.caseVoucherId,
                        refId: caseCtx.objectID,
                        refType: BlameLogRefType.Case,
                        type: BlameLogType.UnknownCaseVoucherMapped,
                    };
                    if (tenantId) {
                        blameLogs.createBlameLog(blameLog, tenantId);
                    }
                }
            }) }, lang.caseVouchers.map)));
};
const SelectedCase = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1em;
  margin-bottom: 1em;
  background: #ddd;
  border-radius: 3px;
`;
export default CaseVoucherTable;
//# sourceMappingURL=CaseVoucherTable.js.map